import {CLEAR_MAIN_REPORT, FETCH_MAIN_REPORT, LIST_MAIN_REPORT} from "./types";
const init = {
    isLoading: false,
    data: {},
    filter: {}
};
export default (state = init, {type, payload}) => {
    switch (type) {
        case FETCH_MAIN_REPORT:
            return {
                ...state,
                filter: payload,
                isLoading: true
            };
        case LIST_MAIN_REPORT:
            return {
                ...state,
                isLoading: false,
                data: payload.data,
            };
        case CLEAR_MAIN_REPORT:
            return {
                isLoading: false,
                data:{}
            };
        default:
            return state

    }
}
